import React, { useState } from "react";
import { Card, CardHeader, CardBody, Form, FormGroup, Label, Input, Button } from "reactstrap";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import NavBar from "../NavBar/navBar";
import axios from "axios";
import { useTranslation } from 'react-i18next';

const ExternalUsers = () => {
  const { t } = useTranslation();
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [labName, setLabName] = useState('');
  const [generatedPassword, setGeneratedPassword] = useState('');
  const [createdEmail, setCreatedEmail] = useState(''); // guarda email antes de limpar
  const [loading, setLoading] = useState(false);
  const [copied, setCopied] = useState(false);

  const handleSubmit = async () => {
    if (!name || !email || !labName) {
      toast.error(t('externalUsers.fillFields'), { position: toast.POSITION.BOTTOM_RIGHT });
      return;
    }
    setLoading(true);
    try {
      const response = await axios.post(
        (process.env.REACT_APP_CUSTOM_URL || 'http://localhost:8000/v1') + '/external-users/',
        { name, email, lab_name: labName },
        {
          headers: {
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + localStorage.getItem('auth_token')
          }
        }
      );
      setGeneratedPassword(response.data.password);
      setCreatedEmail(email); // salva antes de limpar
      toast.success(t('externalUsers.successMsg'), { position: toast.POSITION.BOTTOM_RIGHT });
      setName('');
      setEmail('');
      setLabName('');
      setCopied(false);
    } catch (error) {
      toast.error(t('externalUsers.errorMsg'), { position: toast.POSITION.BOTTOM_RIGHT });
    }
    setLoading(false);
  };

  const handleCopyPassword = () => {
    navigator.clipboard.writeText(generatedPassword).then(() => {
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    });
  };

  return (
    <div className="page-layout">
      <NavBar />
      <div className="dashboard-overview results-page">
        <Card style={{ marginTop: '10px', width: '95%', marginLeft: '10px' }}>
          <CardHeader style={{ color: '#EE7D11', borderBottom: '3px solid', fontSize: '20px' }}>
            {t('externalUsers.title')}
          </CardHeader>
          <CardBody>
            <Form>
              <FormGroup>
                <Label>{t('externalUsers.nameLabel')} *</Label>
                <Input
                  type="text"
                  value={name}
                  onChange={e => setName(e.target.value)}
                  placeholder={t('externalUsers.namePlaceholder')}
                />
              </FormGroup>
              <FormGroup>
                <Label>{t('externalUsers.emailLabel')} *</Label>
                <Input
                  type="email"
                  value={email}
                  onChange={e => setEmail(e.target.value)}
                  placeholder={t('externalUsers.emailPlaceholder')}
                />
              </FormGroup>
              <FormGroup>
                <Label>{t('externalUsers.labLabel')} *</Label>
                <Input
                  type="text"
                  value={labName}
                  onChange={e => setLabName(e.target.value)}
                  placeholder={t('externalUsers.labPlaceholder')}
                />
              </FormGroup>
              {/* white-space: nowrap garante que o texto não quebre e o botão não corte */}
              <Button
                className="custom-button save-upload-delete-button"
                style={{ whiteSpace: 'nowrap', minWidth: 'fit-content' }}
                onClick={handleSubmit}
                disabled={loading}
              >
                {loading ? t('externalUsers.creating') : t('externalUsers.createButton')}
              </Button>
            </Form>

            {generatedPassword && (
              <div style={{
                marginTop: '20px',
                padding: '15px',
                backgroundColor: '#f0f8f0',
                borderRadius: '5px',
                border: '1px solid #4caf50'
              }}>
                <strong>{t('externalUsers.credentialsTitle')}</strong>
                <br /><br />
                <strong>{t('externalUsers.credentialsEmail')}:</strong> {createdEmail}
                <br />
                <strong>{t('externalUsers.credentialsPassword')}:</strong>{' '}
                <span style={{ fontFamily: 'monospace', fontSize: '16px' }}>{generatedPassword}</span>
                {' '}
                <Button
                  size="sm"
                  color={copied ? 'success' : 'secondary'}
                  onClick={handleCopyPassword}
                  style={{ marginLeft: '8px' }}
                >
                  {copied ? t('externalUsers.copied') : t('externalUsers.copy')}
                </Button>
                <br /><br />
                <small style={{ color: '#666' }}>{t('externalUsers.credentialsWarning')}</small>
              </div>
            )}
          </CardBody>
        </Card>
      </div>
      <ToastContainer autoClose={3000} />
    </div>
  );
};

export default ExternalUsers;